export enum TRAVEL_POLICY_PERIOD {
  ONE_DAY = 'ONE_DAY',
  THREE_DAYS = 'THREE_DAYS',
  SEVEN_DAYS = 'SEVEN_DAYS',
}

export enum TRAVEL_RISK_LEVEL {
  HIGH = 'HIGH',
  HIGH_AND_MEDIUM = 'HIGH_AND_MEDIUM',
  NONE = 'NONE',
}

export interface DeviceTravelPolicy {
  riskLevel: TRAVEL_RISK_LEVEL
  riskPeriod: TRAVEL_POLICY_PERIOD
  devicePolicyId?: number
  sensitiveTravelRequestLocation: boolean
}

export interface DeviceTravelHistory {
  travelMembers: {
    travelDevices: DeviceTravel[]
    totalPages: number
  }
  travelLocations: TravelLocation[]
}

export interface DeviceTravelEventHistory {
  events: TravelEvent[]
  totalPages: number
  totalCount: number
  travelLocations: TravelLocation[]
}

export interface TravelLocationHistory {
  travelLocations: TravelLocation[]
  lastUpdated: string
}
export interface DeleteTravelPolicyRequest {
  travelPolicyId: number
}

export interface DeviceTravel {
  id: string
  memberName: string
  deviceName: string | null
  country: string
  risk: string
  lastChecked: string
  guidePolicyCompliance: TravelGuideCompliance
}

export interface TravelEvent {
  eventId: string
  deviceIdentifier: string
  memberName: string
  deviceName: string | null
  country: string
  risk: string
  eventTime: string
  networkCarrier: string | null
}

export interface TravelLocation {
  country: string
  countryCode: string
  riskLevel: TravelRisk
  deviceCount: number
}

export enum TravelRisk {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum TravelGuideCompliance {
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  NOT_ACKNOWLEDGED = 'NOT_ACKNOWLEDGED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
}
